import { createContext, useContext } from 'react'
import { useAuth } from './AuthProvider'
import { useConfig } from './ConfigProvider'
import { GetArchiveInvoiceItems } from '../Services/InvoiceService'
import { toast } from 'react-toastify'

// Listy dokumentów (nieopłacone / archiwum) są pobierane i cache'owane przez
// TanStack Query - patrz src/Hooks/Queries/useInvoicesQueries.jsx.
// Tutaj zostają wyłącznie pozycje pojedynczego dokumentu, pobierane na żądanie
// po rozwinięciu wiersza (dane jednorazowe, bez potrzeby cache'owania).
export const InvoiceContext = createContext()
export const useInvoices = () => {
    return useContext(InvoiceContext)
}

export const InvoicesProvider = ({ children }) => {
    const { api } = useConfig()
    const { logout } = useAuth()

    const handleGetArchiveInvoiceItems = async (invoice) => {
        try {
            const result = await GetArchiveInvoiceItems(api, invoice.nrDoc, invoice.date, invoice.oddzial)
            return result.data
        } catch (e) {
            console.log(e)
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            return []
        }
    }

    const handleGetUnPaidInvoiceItems = async (invoice) => {
        try {
            let yy = invoice.docCreated.slice(2, 4)
            let mm = invoice.docCreated.slice(5, 7)
            let dd = invoice.docCreated.slice(8, 10)

            const result = await GetArchiveInvoiceItems(api, invoice.docNumber, yy + mm + dd, invoice.wh)
            return result.data
        } catch (e) {
            console.log(e)
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            return []
        }
    }

    return (
        <InvoiceContext.Provider value={
            {
                handleGetArchiveInvoiceItems,
                handleGetUnPaidInvoiceItems

            }}>
            {children}
        </InvoiceContext.Provider>
    )
}